// extracted by mini-css-extract-plugin
module.exports = {"container":"Register_container__kwLe2","error":"Register_error__2U54a","inputForm":"Register_inputForm__3B-67","textsizesmall":"Register_textsizesmall__qpufY"};